import React, { memo } from 'react';

import { Block } from '../../components/core';
import { TimeSeriesContent } from './time-series-content';
import { TimeSeriesHeader } from './time-series-header';

import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { TimeSeriesErrorWrapper } from '../../../studio-blocks/components/error-wrappers/TimeSeriesErrorWrapper';

interface TimeSeriesBlockProps {
  id: string;
}

export const TimeSeriesBlock = memo(function InternalTimeSeriesBlock({ id }: TimeSeriesBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <TimeSeriesHeader id={id} />
      </Block.Header>

      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS, TimeSeriesErrorWrapper, MetricsErrorWrapper]}>
        <TimeSeriesContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
